<app-admin-header [header]="'Request permission' | translator" [links]="[]" [breadcrumbs]="breadcrumbs" [stats]="[]">
</app-admin-header>

<div class="permission-flow-shell" *ngIf="!loading; else loadingState">
  <p-toast></p-toast>

  <!-- Success Screen -->
  <section *ngIf="successState" class="flow-panel success-screen">
    <div class="panel-heading">
      <h2>{{ 'Success' | translator }}</h2>
      <p>{{ 'Your account has been created and permission request has been submitted successfully, you will be contacted soon.' | translator }}</p>
    </div>

    <div class="success-content">
      <div class="success-icon">
        <i class="pi pi-check-circle"></i>
      </div>
      <p class="success-detail">{{ 'You can now close this page.' | translator }}</p>
      <div class="panel-actions">
        <button pButton type="button" class="v4-btn-every" label="{{ 'Go to Home' | translator }}" (click)="goToHome()"></button>
      </div>
    </div>
  </section>

  <!-- Main Flow Content -->
  <div *ngIf="!successState">
    <div class="flow-stepper">
    <div
      *ngFor="let option of ['01','02','03']; let idx = index"
      class="step-badge"
      [class.active]="step === (idx + 1)"
      [class.completed]="step > (idx + 1)">
      <span class="index">Step {{ idx + 1 }}</span>
      <span class="label">
        {{
          idx === 0
            ? ('Select permission' | translator)
            : idx === 1
            ? ('Signup' | translator)
            : ('Permission details' | translator)
        }}
      </span>
    </div>
  </div>

  <section *ngIf="step === 1" class="flow-panel">
    <div class="panel-heading">
      <h2>{{ 'Select permission' | translator }}</h2>
      <p>{{ 'Select the permission you need to request.' | translator }}</p>
    </div>
    <div class="permission-card-grid">
      <article
        *ngFor="let option of permissionOptions"
        class="permission-card"
        [class.selected]="selectedPermission === option.value"
        (click)="selectPermission(option.value)">
        <div class="card-accent" [ngClass]="option.accent"></div>
        <div class="card-icon">
          <i [class]="option.icon"></i>
        </div>
        <div class="card-body">
          <h3>{{ option.title | translator }}</h3>
        </div>
        <div class="card-footer">
          <span>{{ selectedPermission === option.value ? ('Selected' | translator) : ('Select' | translator) }}</span>
          <i class="pi pi-arrow-left"></i>
        </div>
      </article>
    </div>
    <div class="panel-actions">
      <button pButton type="button" class="v4-btn-every" label="{{ 'Cancel' | translator }}" routerLink="/home"></button>
      <button pButton type="button" class="v4-btn-every" label="{{ 'Continue to sign up' | translator }}" (click)="goToSignupStep()"></button>
    </div>
  </section>

  <section *ngIf="step === 2" class="flow-panel">
  
    <form [formGroup]="signupForm" novalidate>
      <div class="card-scroll">
        <div class="row">
          <div class="col-lg-4">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="fName">{{ "First Name" | translator }}
            </label>
            <input type="text" id="fName" placeholder="{{ 'Type the first name' | translator }}"
              pattern="[\u0600-\u06FF\s]+" formControlName="fName" pInputText class="w-full mb-3 ms-input-view" />
            <div class="error" *ngIf="
                signupForm.controls['fName'].invalid &&
                (signupForm.controls['fName'].dirty ||
                  signupForm.controls['fName'].touched)
              ">
              <div *ngIf="signupForm.controls['fName'].errors?.['required']">
                {{ "The name is required" | translator }}
              </div>
              <div *ngIf="signupForm.controls['fName'].errors?.['minlength']">
                {{ "The name must be at least 3 characters" | translator }}
              </div>
              <div *ngIf="signupForm.controls['fName'].errors?.['pattern']">
                {{ "Please write in Arabic" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="mName">{{ "the second name" | translator
              }}</label>
            <input type="text" id="mName" placeholder="{{ 'Type the second name (optional)' | translator }}"
              pattern="[\u0600-\u06FF\s]+" formControlName="mName" pInputText class="w-full mb-3 ms-input-view" />
            <div class="error" *ngIf="
                signupForm.controls['mName'].invalid &&
                (signupForm.controls['mName'].dirty ||
                  signupForm.controls['mName'].touched)
              ">
              <div *ngIf="signupForm.controls['mName'].errors?.['pattern']">
                {{ "Please write in Arabic" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-4">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="lName">{{ "family name" | translator
              }}</label>
            <input type="text" id="lName" placeholder="{{ 'Type the last name' | translator }}"
              pattern="[\u0600-\u06FF\s]+" formControlName="lName" pInputText class="w-full mb-3 ms-input-view" />
            <div class="error" *ngIf="
                signupForm.controls['lName'].invalid &&
                (signupForm.controls['lName'].dirty ||
                  signupForm.controls['lName'].touched)
              ">
              <div *ngIf="signupForm.controls['lName'].errors?.['required']">
                {{ "The name is required" | translator }}
              </div>
              <div *ngIf="signupForm.controls['lName'].errors?.['minlength']">
                {{ "The name must be at least 3 characters" | translator }}
              </div>
              <div *ngIf="signupForm.controls['lName'].errors?.['pattern']">
                {{ "Please write in Arabic" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-12">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="email">{{ "E-mail address" | translator
              }}</label>
            <input type="email" id="email" placeholder="{{ 'Type the email address' | translator }}"
              formControlName="email" pInputText class="w-full mb-3 text-start ms-input-view" />
            <div class="error" *ngIf="
                signupForm.controls['email'].invalid &&
                (signupForm.controls['email'].dirty ||
                  signupForm.controls['email'].touched)
              ">
              <div *ngIf="signupForm.controls['email'].errors?.['required']">
                {{ "Email required" | translator }}
              </div>
              <div *ngIf="signupForm.controls['email'].errors?.['email']">
                {{ "Email is invalid" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="phone">{{ "Mobile Phone Number" | translator
              }}</label>
            <input type="text" id="phone" placeholder="--------- 966 00" formControlName="phone" pInputText
              class="w-full mb-3 ms-input-view" />
            <div class="error" *ngIf="
                signupForm.controls['phone'].invalid &&
                (signupForm.controls['phone'].dirty ||
                  signupForm.controls['phone'].touched)
              ">
              <div *ngIf="signupForm.controls['phone'].errors?.['required']">
                {{ "Mobile phone number is required" | translator }}
              </div>
              <div *ngIf="signupForm.controls['phone'].errors?.['pattern']">
                {{ "Invalid mobile phone number" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="national_id">{{ "National Identity" |
              translator }}</label>
            <input type="text" id="national_id" placeholder="xxxxxxxxxx" formControlName="national_id" pInputText
              class="w-full mb-3 ms-input-view" />
            <div class="error" *ngIf="
                signupForm.controls['national_id'].invalid &&
                (signupForm.controls['national_id'].dirty ||
                  signupForm.controls['national_id'].touched)
              ">
              <div *ngIf="signupForm.controls['national_id'].errors?.['required']">
                {{ "National ID is required" | translator }}
              </div>
              <div *ngIf="signupForm.controls['national_id'].errors?.['pattern']">
                {{ "The national ID is invalid" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 ppp-dropdown">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="gender">{{ "Sex" | translator }}</label>
            <p-dropdown id="gender" [options]="[{label: 'ذكر'}, {label: 'أنثى'}]" placeholder="{{ 'Choose gender' | translator }}"
              formControlName="gender" class="ppp-dropdown sstarabic w-100">
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
            <div class="error" *ngIf="
                signupForm.controls['gender'].invalid &&
                (signupForm.controls['gender'].dirty ||
                  signupForm.controls['gender'].touched)
              ">
              <div *ngIf="signupForm.controls['gender'].errors?.['required']">
                {{ "Please Select Gender" | translator }}
              </div>
            </div>
          </div>
          <div class="col-lg-6 ppp-dropdown">
            <label class="block text-900 font-medium mb-2 ms-label-view" for="city">{{ "City" | translator }}
            </label>
            <p-dropdown id="city" [options]="city" placeholder="{{ 'Select city' | translator }}"
              formControlName="location" (onChange)="changeCityFilter()" class="ppp-dropdown sstarabic w-100"
              optionLabel="label" optionValue="value">
              <ng-template let-item pTemplate="item">
                <i [ngClass]="item.icon"></i>
                {{ item.label }}
              </ng-template>
            </p-dropdown>
            <div class="error" *ngIf="
                signupForm.controls['location'].invalid &&
                (signupForm.controls['location'].dirty ||
                  signupForm.controls['location'].touched)
              ">
              <div *ngIf="signupForm.controls['location'].errors?.['required']">
                {{ "City is required" | translator }}
              </div>
            </div>
          </div>

          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-4 my-2" *ngFor="let ous of selectedOus; let i = index">
                <div class="ou-boxes">
                  <div class="d-flex justify-content-between mt-1">
                    <span class="ou-list-hover color-grey v4-font-600">{{
                      ous?.type?.name
                      }}</span>
                    <button class="close-btn" (click)="deleteOU(i)">
                      <i class="fa fa-times"></i>
                    </button>
                  </div>
                  <div class="ou-list">
                    <span class="color-grey"> {{ ous?.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 ppp-dropdown" [hidden]="filtredOus.length <= 0">
            <label class="block text-900 font-medium mb-2 ms-label-view OUDD" for="city">{{
              selectionName }}</label>
            <p-dropdown #OUDD styleClass="w-100 p-dropdown-items-wrapper" appendTo="body"
              (onChange)="handleOU($event.value._id); OUDD.resetFilter();" [options]="filtredOus" optionLabel="name"
              [filter]="true" [showClear]="true" filterBy="name" placeholder="{{ 'Choose an organizational unit' | translator }} {{
                selectionName
              }}">
            </p-dropdown>
          </div>

          <div class="d-flex flex-column align-items-start justify-content-start gap-2 mt-2">
            <re-captcha id="flowRecaptcha" formControlName="recaptcha"
              (notloaded)="captchaNotLoaded = true"
              [class.is-invalid]="signupForm.get('recaptcha')?.invalid && (signupForm.get('recaptcha')?.dirty || signupForm.get('recaptcha')?.touched)">
            </re-captcha>
            <div *ngIf="captchaNotLoaded" class="alert alert-warning d-flex flex-row align-items-center">
              <span>{{ "Captcha was not loaded due to internet connectivity. Please click the icon to reload." | translator }}</span>
              <div class="d-flex">
                <div class="tabel-circle-btn" [pTooltip]="'Reload Captcha' | translator" (click)="reloadCaptcha()"><i class="pi pi-refresh"></i></div>
              </div>
            </div>
            <div
              *ngIf="signupForm.get('recaptcha')?.invalid && (signupForm.get('recaptcha')?.dirty || signupForm.get('recaptcha')?.touched)"
              class="invalid-feedback">
              <div *ngIf="signupForm.get('recaptcha')?.errors?.['required']">{{'are required'|translator}}</div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="panel-actions">
      <button pButton type="button" class="v4-btn-every" label="{{ 'Back' | translator }}" (click)="goBack()"></button>
      <button pButton type="button" class="v4-btn-every" label="{{ 'Continue to details' | translator }}" (click)="proceedToRequestDetails()"></button>
    </div>
  </section>

  <section *ngIf="step === 3" class="flow-panel">
    

    <div class="summary-badge">
      <div>
        <span>{{ 'Permission' | translator }}:</span>
        <strong>
          {{
            selectedPermission
              ? (selectedPermission | translator)
              : ('Not selected' | translator)
          }}
        </strong>
      </div>
      <div>
        <span>{{ 'Applicant' | translator }}:</span>
        <strong>{{ signupForm.value.fName }} {{ signupForm.value.lName }}</strong>
      </div>
      
    </div>

    <app-permission-requests-form
      *ngIf="selectedPermissionOption"
      [defaultRequestType]="selectedPermissionOption"
      [lockRequestType]="true"
      [suppressRedirect]="true"
      [contactPrefill]="permissionContactPrefill"
      [hideNativeActions]="true">
    </app-permission-requests-form>

    <div class="panel-actions final">
      <button pButton type="button" class="v4-btn-every" label="{{ 'Back' | translator }}" (click)="goBack()"></button>
      <button pButton type="button" class="v4-btn-every"
        label="{{ requestInProgress ? ('Processing...' | translator) : ('Create request' | translator) }}"
        [disabled]="requestInProgress"
        (click)="submitFlow()">
      </button>
    </div>
  </section>
  </div>
</div>

<ng-template #loadingState>
  <div class="loading-state">
    <p-progressSpinner></p-progressSpinner>
    <p>{{ 'Loading...' | translator }}</p>
  </div>
</ng-template>

<app-footer></app-footer>

